import 'deal.scss'
import {openModal} from './modal';
import {createSlider} from './slider';

function setupImagePreview() {
    const mainImage = document.querySelector('.main-image img');
    if (!mainImage) return;

    const oriSrc = mainImage.src;

    const images = document.querySelectorAll('.thumbnails .image');
    let lastImage = images.item(0);
    lastImage.classList.add('active');

    const activeImage = document.querySelector('#active-image');
    activeImage.innerHTML = '1 / ' + images.length;

    function show(image, src) {
        mainImage.src = src;
        if (lastImage) lastImage.classList.remove('active');
        lastImage = image;
        image.classList.add('active');
    }

    for (const image of images) {
        const img = image.querySelector('img');

        image.addEventListener('mouseenter', () => {
            show(image, img.src);
        });

        image.addEventListener('touch', () => {
            show(image, img.src);
        });
    }
}

document.addEventListener("DOMContentLoaded", function () {
    setupImagePreview();
    createSlider('.thumbnails', '#active-image');
});

window.openModal = openModal;
